<div class="container-fluid page">
  <div class="page-content shadow position-relative">
    <mat-tab-group>
      <mat-tab label="Roles List">
        <ng-template matTabContent>
          <div class="px-4 mt-2">
            <div class="d-flex justify-content-start pt-1 my-1">
              <form
                [formGroup]="filterForm"
                class="mat-form d-flex align-items-center gap-10">
                <app-input-select
                  (selectionChange)="applyFilter()"
                  [inputData]="attrConstant.roleType"
                  [selectOptions]="roleType"
                  [bindLabel]="'label'"
                  [bindValue]="'value'"
                  [formControlName]="
                    attrConstant.roleType.key
                  "></app-input-select>
                <img
                  src="assets/images/clear-filter.svg"
                  class="clear-img"
                  alt="clear-filter"
                  matTooltip="Clear Filters"
                  matTooltipPosition="above"
                  [attr.aria-hidden]="true"
                  (click)="clearFilters()" />
              </form>
            </div>
            <table
              mat-table
              matSort
              [matSortActive]="activeSort?.active ?? 'created_at'"
              [matSortDirection]="activeSort?.direction ?? 'desc'"
              [dataSource]="dataSource"
              (matSortChange)="onSortChange($event)">
              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let element" data-label="Name">
                  {{ element.name }}
                </td>
              </ng-container>

              <!-- Role Type Column -->
              <ng-container matColumnDef="role_type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Role Type
                </th>
                <td mat-cell *matCellDef="let element" data-label="Role Type">
                  {{ element.role_type }}
                </td>
              </ng-container>

              <!-- Description Column -->
              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Description
                </th>
                <td mat-cell *matCellDef="let element" data-label="Description">
                  {{ element.description !== '' ? element.description : '--' }}
                </td>
              </ng-container>

              <!-- Action Column -->
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>
                  <ng-container
                    *appHasAccess="'/user-management/role/edit/:id'">
                    Action
                  </ng-container>
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Action"
                  (click)="$event.stopPropagation()">
                  <div class="d-flex align-items-center action-gap-10">
                    <img
                      src="assets/images/edit-icon.svg"
                      alt="edit-icon"
                      matTooltip="Edit"
                      matTooltipPosition="left"
                      [routerLink]="[
                        '/user-management/role/edit',
                        element.role_id,
                      ]"
                      *appHasAccess="'/user-management/role/edit/:id'" />
                    <img
                      src="assets/images/delete-icon.svg"
                      alt="delete-icon"
                      matTooltip="Delete"
                      matTooltipPosition="right"
                      [attr.aria-hidden]="true"
                      (click)="onDeleteRole(element.role_id)"
                      *appHasAccess="'delete-role'" />
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                class="custom-mat-btn"
                *matRowDef="
                  let row;
                  columns: displayedColumns;
                  let element
                "></tr>
            </table>
            <mat-paginator
              showFirstLastButtons
              [pageIndex]="page"
              [length]="total"
              [pageSize]="limit"
              [pageSizeOptions]="[10, 20, 50, 100, 200]"
              (page)="onPageChange($event)">
            </mat-paginator>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab disabled *appHasAccess="'/user-management/role/add'">
        <ng-template mat-tab-label>
          <a
            class="btn primary-btn"
            [routerLink]="['/user-management/role/add']">
            Add Role
          </a>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
